import { FormsView } from "./_components";

export default function FormsPage() {
  return <FormsView />;
}
